import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name: string;
}

interface UserStore {
  user: User | null;
  credits: number;
  setUser: (user: User | null) => void;
  setCredits: (credits: number) => void;
  logout: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    set => ({
      user: null,
      credits: 0, // Server is source of truth; synced on auth
      setUser: user => set({ user }),
      setCredits: credits => set({ credits }),
      logout: () => set({ user: null, credits: 0 }),
    }),
    {
      name: 'photofeeler-user',
    }
  )
);
